import { render, staticRenderFns } from "./PageInviteAFriend.vue?vue&type=template&id=2ef06e81&scoped=true"
import script from "./PageInviteAFriend.vue?vue&type=script&lang=js"
export * from "./PageInviteAFriend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef06e81",
  null
  
)

export default component.exports